import React, { useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import Navbar from '../Navbar/Navbar';
import './MainLayout.css';
import { useThemeContext } from '../../../Context/ThemeContext';
import Sidebar from '../Sidebar/Sidebar';
import MobileSidebar from '../MobileSidebar/MobileSidebar';
import { DARKCOLORS, LIGHTCOLORS } from '../../../Utils/constants';

const MainLayout = ({ children }) => {
  const { mode } = useThemeContext(); // Access current theme mode
  // Use useMediaQuery to detect screen size below 1024px
  const isMobile = useMediaQuery('(max-width:1200px)');

  const [isSidebarOpen, setSidebarOpen] = useState(!isMobile);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const mainLayoutStyle = {
    minWidth: "100%",
    minHeight: '100vh',
    backgroundColor: mode === 'light' ? LIGHTCOLORS.BackgroundDashboard : DARKCOLORS.BackgroundDashboard,
    color: mode === 'light' ? LIGHTCOLORS.HeadingLightBackground : DARKCOLORS.HeadingLightBackground,
  };

  return (
    <div style={mainLayoutStyle}>
      <Navbar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
      <Box height={73} />
      <Box sx={{ display: 'flex',width:'100%' }}>
        {/* Conditionally render Sidebar or MobileSidebar based on screen size */}
        {isMobile ? (
          <MobileSidebar open={isSidebarOpen} toggleSidebar={toggleSidebar} />
        ) : (
          <Sidebar open={isSidebarOpen} />
        )}
        {children}
      </Box>
    </div>
  );
};

export default MainLayout;
